import api from '@/shared/services/api'
const routes = [
    {
        path: '/inicio',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'visualizarDashboard',
                path: '',
                alias: ['/inicio', '/dashboard/index'],
                component: () => import('../views/Iniciar'),
                beforeEnter: async (to, from, next) => {
                    try {
                        const res = await api.post('/modalidades/validar_url', {
                            url: '/inicio'
                        })
                        if (res.status == 'success') {
                            next()
                        } else {
                            location.href = res.data.url
                        }
                    } catch (erro) {
                        next()
                    }
                }
            },
        ]
    }
]

export default routes
